import { css } from "@emotion/react"

import Spinner from "../../ui/Spinner/Spinner"
import { resolveButtonClassName, overrideButtonStyle } from "./resolveButtonStyle"

type Props = {
  type?: "button" | "submit"
  children?: React.ReactNode
  onClick?: React.MouseEventHandler<HTMLButtonElement>
  overrideStyle?: Parameters<typeof overrideButtonStyle>[0]
} & Parameters<typeof resolveButtonClassName>[0]

const Button = ({ type = "button", children, onClick, overrideStyle, ...props }: Props) => {
  const { disabled = false, isLoading = false } = props

  return (
    <button
      type={type}
      css={resolveButtonClassName(props)}
      onClick={onClick}
      disabled={disabled || isLoading}
      style={overrideButtonStyle(overrideStyle)}
    >
      {isLoading && (
        <span css={styles.spinnerContainer}>
          <Spinner size="small" color="white" />
        </span>
      )}
      {children}
    </button>
  )
}

export default Button

const styles = {
  spinnerContainer: css`
    position: absolute;
    top: 7px;
    left: 8px;
  `,
}
